import Organization from 'services/organization';
import { useOrganizationStore, useSubscriptionsStore, useUserStore } from 'store/modules';
import { SUSPENDED_BILLING_ROUTES } from './constants';

export default function (to, from, next) {
    const userStore = useUserStore();
    const organizationStore = useOrganizationStore();
    const subscriptionsStore = useSubscriptionsStore();

    const user = userStore.user;
    const organization = organizationStore.organization;
    const subscription = subscriptionsStore.subscription;

    if (
        !user ||
        !organization ||
        !subscription ||
        ['active', 'trialing', 'past_due'].includes(subscription.status)
    ) {
        if (to.name === 'suspended') {
            next('/');

            return;
        }

        next();
        return;
    }

    const isOwner = user.id === organization.owner_id;

    if (isOwner && Organization.isAgencyWithoutSubscription) {
        next();
        return;
    }

    if (
        isOwner &&
        !SUSPENDED_BILLING_ROUTES.includes(to.name) &&
        !SUSPENDED_BILLING_ROUTES.includes(to.path)
    ) {
        // Owners can see /suspended and billing overview/upgrade (for "Restart Subscription").
        next('/suspended');
    } else if (!isOwner && to.name !== 'suspended') {
        // Members are jailed to /suspended.
        next('/suspended');
    } else {
        // The user is on a page they can see.
        next();
    }
}
